import { render } from "./AddAproposPage.vue?vue&type=template&id=e2606cfe&ts=true"
import script from "./AddAproposPage.vue?vue&type=script&lang=ts"
export * from "./AddAproposPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__